export const isWhitelistedPath = (pathname: string | null, whiteListedPages: string[]) => {
	const normalizedPathname = pathname || '/';

	return whiteListedPages.some((page) => {
		const normalizedPage = page === '' ? '/' : page;
		return normalizedPage === '/'
			? normalizedPathname === '/'
			: normalizedPathname === normalizedPage || normalizedPathname.startsWith(`${normalizedPage}/`);
	});
};
